import { NotificaInApp } from '@ideapa/app-shared-notifica';
import { createAction, props } from '@ngrx/store';

export const getUserLatestNotifications = createAction(
  '[Ngrx/Notifications] Get User Latest Notifications'
);

export const getUserLatestNotificationsSuccess = createAction(
  '[Ngrx/Notifications] Get User Latest Notifications Success',
  props<{ items: NotificaInApp[]; counter: number }>()
);

export const getUserLatestNotificationsFailure = createAction(
  '[Ngrx/Notifications] Get User Latest Notifications Failure',
  props<{ error: string }>()
);

export const subscribeUserNotifications = createAction(
  '[Ngrx/Notifications] Subscribe User Notifications'
);

export const subscribeUserNotificationsFailure = createAction(
  '[Ngrx/Notifications] Subscribe User Notifications Failure',
  props<{ error: string }>()
);
